<template>
  <div class="h3c-header" id="h3c-header" :class="propClass">
    <!--    <div class="logo">-->
    <!--      <img src="../../../../assets/images/logo-icon.png" alt="" />-->
    <!--    </div>-->
    <div class="navigate">
      <ul class="header-tab">
        <div class="logo">
          <!--        需要更改logo   -->
          <img src="../../../../assets/images/logo-iconEN.png" alt="" @click="handleLogo" />
        </div>
        <li
          v-for="item in menuItems"
          :key="item.id"
          :class="{ active: activeKey === item.id }"
          @click.prevent="scrollTo(item)"
        >
          {{ item.label }}
        </li>
        <div class="language">
          <img src="" alt="" />
          <span>
            <a class="language-text" @click="handleClickLangCN">CN</a>
          </span>
          <span class="ml-2 mr-2">·</span>
          <span>
            <a class="language-text" @click="handleClickLangEN">EN</a>
          </span>
          <img src="" alt="" />
        </div>
      </ul>
    </div>
    <div class="right">
      <div class="login" v-if="!getCookies" @click="handleClickReservationTwo">Login</div>
      <div class="qr-code-wrapper fs-20 login-img" v-else v-click-outside="pullDown">
        <div @click="dropDown = !dropDown">
          <img src="../../../../assets/images/headIcon.png" alt="" class="headIcon" />
        </div>
        <div class="qr-code" v-if="dropDown">
          <div class="login-user">
            <!--            <div class="user">Personal</div>-->
            <div @click="handleClickLogOut" class="loginOut">Exit</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--  中文版登录 -->
  <!-- 英文版登录 -->
  <!--  <login-en-->
  <!--    v-model:visible="visibleTwo"-->
  <!--    @update:visible="handleVisibleTwoChange"-->
  <!--    :event-info="eventInfo"-->
  <!--  />-->
</template>

<script>
// watch,
import {
  ref,
  toRefs,
  getCurrentInstance,
  reactive,
  onMounted,
  onBeforeUnmount,
  watchEffect
} from 'vue'

// import loginEn from '../../components/loginEn'
import { useStore } from 'vuex'
import Cookies from 'js-cookie'
import { useRoute, useRouter } from 'vue-router'
import { newsList } from '@/service/api/pc'
import { session } from '@/utils/storage'
// import { message } from 'ant-design-vue'

export default {
  name: 'h3cHeader',
  props: { propClass: Object },
  components: {
    // loginEn
  },
  setup() {
    const store = useStore()
    const route = useRoute()
    const router = useRouter()
    const menuItems = [
      { id: 'summit-homepage', label: 'Home', routeName: 'pc-home' },
      // { id: 'summit-overview', label: 'Overview' },
      { id: 'summit-agenda', label: 'Agenda', routeName: 'pc-agenda' },
      { id: 'summit-guests', label: 'Speakers', routeName: 'pc-speaker' }
      // { id: 'summit-news', label: 'News', routeName: 'pc-news' }
      // { id: 'attending-guidelines', label: 'Participation Guide' }
      // { id: 'previous-summits', label: 'Previous Summits' }
    ]
    const state = reactive({
      getCookies: false,
      activeKey: 'summit-homepage',
      currentMinPositiveNode: null,
      scrollTimeoutId: null,
      lastScrollTime: Date.now(),
      show: true
    })
    const dropDown = ref(false)
    newsList().then((res) => {
      if (res.length > 0) {
        let obj = { id: 'summit-news', label: 'News', routeName: 'pc-news' }
        menuItems.push(obj)
      }
    })
    const handleClickLogOut = () => {
      // 在个人中心退出登录后跳转至首页，判断router name
      state.getCookies = false
      dropDown.value = false
      const domain = process.env.NODE_ENV === 'production' ? 'h3c.com' : 'localhost'
      const url = new URL(window.location.href)
      const domainName = url.hostname
      Cookies.remove('h3c_user', { domain: domain })
      Cookies.remove('h3c_user', { domain: domainName })
      session.remove('h3c_user')
      store.commit('userStore/changeUser', {})
      if (route.name === 'pc-session') {
        router.push({ name: 'pc-home', query: route.query })
      }
    }
    const handleScroll = () => {
      if (route.name !== 'pc-home') return false
      const nodes = menuItems.map((item) => document.getElementById(item.id))
      const visibleNodes = nodes.filter((node) => {
        const rect = node.getBoundingClientRect()
        return rect.top > 0 && rect.top <= window.innerHeight
      })
      visibleNodes.sort((a, b) => {
        const aRect = a.getBoundingClientRect()
        const bRect = b.getBoundingClientRect()
        return aRect.top - bRect.top
      })
      let minPositiveNode

      if (visibleNodes.length > 0) {
        minPositiveNode = visibleNodes[0]
      } else {
        // 如果可见节点为空，则选择距离视口顶部最近的节点
        nodes.sort((a, b) => {
          const aRect = a.getBoundingClientRect()
          const bRect = b.getBoundingClientRect()
          return Math.abs(aRect.top) - Math.abs(bRect.top)
        })
        minPositiveNode = nodes[0]
      }
      if (minPositiveNode !== state.currentMinPositiveNode) {
        console.log(`距离视口顶部最小且大于零的节点中的最小节点已更改为 ${minPositiveNode?.id}`)
        // 最小节点改变时执行的操作
        state.currentMinPositiveNode = minPositiveNode
      }
      state.currentMinPositiveNode?.id && (state.activeKey = state.currentMinPositiveNode?.id)
    }

    const handleScrollThrottled = () => {
      // 记录最近一次触发滚动事件的时间戳
      state.lastScrollTime = Date.now()
      if (state.scrollTimeoutId !== null) {
        clearTimeout(state.scrollTimeoutId)
      }

      // 设置新的滚动事件检查
      state.scrollTimeoutId = setTimeout(() => {
        const currentTime = Date.now()
        const timeSinceLastScroll = currentTime - state.lastScrollTime
        console.log(`距离上一次滚动事件的时间：${timeSinceLastScroll}毫秒`)
        if (timeSinceLastScroll >= 500) {
          console.log('滚动事件已结束')
          // 滚动事件结束后执行的操作

          handleScroll()
        }
        state.scrollTimeoutId = null
      }, 500)
    }
    onMounted(() => {
      // window.addEventListener('scroll', handleScrollThrottled)
    })
    onBeforeUnmount(() => {
      // window.addEventListener('scroll', handleScrollThrottled)
    })
    const { proxy } = getCurrentInstance()

    watchEffect(() => {
      // if (route.name !== 'pc-home') {
      //   state.activeKey = ''
      // }
      let menu = menuItems.find((item) => item.routeName === route.name)
      if (menu) {
        state.activeKey = menu.id
      } else {
        state.activeKey = ''
      }
    })

    watchEffect(() => {
      if (store.state.userStore.user.id) {
        state.getCookies = true
      } else {
        state.getCookies = false
      }
    })
    let userDate = Cookies.get('h3c_user')
    if (userDate) {
      state.getCookies = true
    }
    return {
      menuItems,
      handleScrollThrottled,
      handleClickLogOut,
      dropDown,
      ...toRefs(state),
      handleClickLangCN() {
        window._gsq.push(['track', 'Navigation', { page_name: '峰会网页', button_name: '中文' }])

        if (process.env.VUE_APP_MODE === 'production') {
          window.open('https://navigate.h3c.com/2023/home', '_self')
        } else {
          window.open('https://navigate-ts.h3c.com/2023/home', '_self')
        }
      },
      handleClickLangEN() {
        window._gsq.push(['track', 'Navigation', { page_name: '峰会网页', button_name: '英文' }])

        if (process.env.VUE_APP_MODE === 'production') {
          window.open('https://navigate.h3c.com/en/2023/home', '_self')
        } else {
          window.open('https://navigate-ts.h3c.com/en/2023/home', '_self')
        }
      },
      handleLogo: () => {
        window.open('https://www.h3c.com/en/', '_blank')
      },
      handleClickReservationTwo() {
        // state.getCookies = true
        window._gsq.push(['track', 'Login', { page_name: '峰会网页', button_name: '登录' }])

        state.eventInfo = { eventid: 228 }
        proxy.$bus.emit('changeAuthenticationTwo', true)
      },
      cn() {},
      en() {},
      pullDown() {
        dropDown.value && (dropDown.value = false)
      },
      scrollTo({ id, label, routeName }) {
        if (routeName && router.hasRoute(routeName) && routeName !== route.name) {
          router.push({ name: routeName })
        } else if (label === 'Participation Guide') {
          if (route.name !== 'pc-home') {
            session.set('scrollId', id)
            router.push({ name: 'pc-home', query: route.query })
          } else {
            state.activeKey = id
            const elem = document.getElementById(id)
            if (elem) {
              elem.scrollIntoView({
                behavior: 'smooth',
                // block: 'center',
                inline: 'nearest'
              })
            }
          }
          // window.open('https://navigate.h3c.com/2020/en/')
        }

        window._gsq.push(['track', 'Navigation', { page_name: '峰会网页', button_name: label }])
        // state.activeKey = id
        // const elem = document.getElementById(id)
        // if (elem) {
        //   elem.scrollIntoView({
        //     behavior: 'smooth',
        //     // block: 'center',
        //     inline: 'nearest'
        //   })
        // }
      }
    }
  }
}
</script>

<style lang="less" scoped>
ul,
li {
  list-style: none;
  padding: 0;
  margin: 0;
}
.h3c-header {
  width: 100%;
  height: 80px;
  display: flex;
  position: relative;
  background-color: rgba(47, 51, 55, 1);
  backdrop-filter: blur(8px);
  //.left {
  //  flex: 1;
  //  min-width: 240px;
  //  height: 40px;
  //  padding: 20px 0;
  //}
  .logo {
    padding: 20px 0;
    display: flex;
    margin-left: auto;
    img {
      width: 240px;
      height: 40px;
    }
  }
  .navigate {
    width: 1200px; /* no-pxtorem */
    height: 100%;
    margin: 0 auto;
    display: flex;
    .header-tab {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      width: 100%;
      color: #ffffff;
      font-size: 16px;
      //left: 79px;
      .logo {
        padding: 20px 0;
        position: absolute;
        left: 0px;
        transform: translateX(-100%);
        img {
          cursor: pointer;
          width: 60px;
          height: 60px;
        }
      }
      li {
        font-size: 16px;
        height: 80px;
        line-height: 80px;
        margin: 0 0 0 40px;
        cursor: pointer;
        //padding: 20px 0;
        &.active {
          position: relative;
          background: linear-gradient(to right, #4dd2ff, #bfffff, #4dff89);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          &:after {
            content: '';
            width: 100%;
            height: 2px;
            position: absolute;
            background: linear-gradient(90deg, #0e9ccc 0%, #18d3d3 50%, #14e38e 100%);
            bottom: 0;
            left: 0;
          }
        }
      }
      .language {
        cursor: pointer;
        position: absolute;
        right: 0;
        transform: translateX(100%);
        //width: 78px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        font-family: FZLanTingHeiS-R-GB-Regular, FZLanTingHeiS-R-GB;
        padding-left: 40px;
        font-weight: 400;
      }
    }
  }
  .right {
    position: absolute;
    right: 0;
    top: 0;
    height: 80px;
    display: flex;
    color: #ffffff;
    .login {
      min-width: 120px;
      background: linear-gradient(90deg, #0a97c7 0%, #00cccc 62%, #27d990 100%);
      font-size: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    .login-img {
      min-width: 120px;
      font-size: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.qr-code-wrapper {
  position: relative;
  .btn-go {
    background: linear-gradient(90deg, #0a97c7 0%, #00cccc 62%, #27d990 100%);
    padding: 12px 30px;
    cursor: pointer;
  }
  .qr-code {
    // longin-bac
    position: absolute;
    bottom: -168px;
    width: 100px;
    height: 80px;
    background-image: url('../../../../assets/images/longin-bac.png');
    background-size: cover;
    //z-index: -2;
    top: 65px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 10px;
  }
  .login-user {
    color: #4c4948;
    font-size: 16px;
    cursor: pointer;
  }
}
.loginOut:hover {
  background: linear-gradient(to right, #0a97c7, #00cccc, #27d990);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
}
.headIcon {
  width: 40px;
  height: 40px;
}
.language-text {
  color: #ffffff;
}
</style>
